import { Text } from '@chakra-ui/react'
import { TextProps } from './utils'

const SectionBody = ({ children, color, ...textProps }: TextProps) => (
  <Text as="p" fontSize="md" fontWeight={500} color={color} {...textProps}>
    {children}
  </Text>
)

export { SectionBody }
